/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Enum that represents the dotNet Charge processor enums
 */
export enum PaymentProcessor {
	None = 'None',
	PayPal = 'PayPal',
	Stripe = 'Stripe',
	Square = 'Square',
	CognitoPay = 'CognitoPay',
	CognitoDemo = 'CognitoDemo',
}
